






















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import ButtonPanel from '@/components/ButtonPanel.vue';
import { WareHouse, AppointmentTime } from '@/http';
import { enums } from '@/common/enums';
import DescribePanel from '@/components/DescribePanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
@Component({
    components: { BaseContainer, ButtonPanel, PageDescribe, DescribePanel, BaseInfoPanel },
})
export default class timeWindowEdit extends Vue {
    public $refs: {
        form: HTMLFormElement;
        PWEdit: HTMLFormElement;
        DescribePanel: HTMLFormElement;
    };
    public content: any;
    public dateList = [];
    public wareHouseNamesList = [];
    public form: any = {
        startDate: '',
        endDate: '',
        wareHouseIds: '',
        wareHouseNames: '',
        isEnabled: true,
        timesInfoList: [
            {
                id: '',
                startTime: '',
                endTime: '',
                trainNumberLimit: null,
                appointmentTimeList: [],
            },
        ],
    };
    public setColor: string = '';
    // 验证规则
    public formRules = formRules;
    public loading: boolean = false;
    public pageTitle: any = '';
    public contant: string = '';
    public id: any = '';
    public wareHouseList = [];

    created() {
        this.GetWarehouseList();
    }

    mounted() {
        this.pageTitle = this.$route.query.pageTitle;
        if (this.pageTitle == '新增时间窗口') {
            this.contant = '新增、编辑时间窗口，支持一个仓库多个时间窗口，支持禁用仓库的时间窗口';
            this.reset();
        } else {
            this.contant = '新增、编辑时间窗口，支持一个仓库多个时间窗口，支持禁用仓库的时间窗口';
            this.id = this.$route.query.id;
            this.loadDetail();
        }
    }
    /**
     * 获取仓库列表
     */
    public wareHouseIdList = [];
    public async GetWarehouseList() {
        await WareHouse.GetWareHouseList({
            enabled: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.wareHouseList = res.data;
            if (this.wareHouseList) {
                this.wareHouseList.forEach((e) => {
                    this.wareHouseIdList.push(e.id);
                });
            }
        });
    }
    public reset() {
        this.form = {
            startDate: '',
            endDate: '',
            wareHouseIds: '',
            wareHouseNames: '',
            isEnabled: true,
            timesInfoList: [
                {
                    id: '',
                    startTime: '',
                    endTime: '',
                    trainNumberLimit: null,
                },
            ],
        };
        this.dateList = [];
    }
    public addBook() {
        this.form.timesInfoList.push({
            id: '',
            startTime: '',
            endTime: '',
            trainNumberLimit: null,
        });
    }
    public wareHouseNames = [];
    public wareHouseChange() {
        this.wareHouseNames = [];
        this.form.wareHouseIds = this.wareHouseNamesList.join(',');
        for (let i = 0; i < this.wareHouseNamesList.length; i++) {
            this.wareHouseList.forEach((e) => {
                if (this.wareHouseNamesList[i] == e.id) {
                    this.wareHouseNames.push(e.name);
                }
            });
        }
        this.form.wareHouseNames = this.wareHouseNames.join(',');
    }
    public daterange(v) {
        if (v) {
            this.form.startDate = v[0];
            this.form.endDate = v[1];
        } else {
            this.form.startDate = null;
            this.form.endDate = null;
        }
    }
    public datetimerange(v, index) {
        if (v) {
            this.form.timesInfoList[index].startTime = v[0];
            this.form.timesInfoList[index].endTime = v[1];
        } else {
            this.form.timesInfoList[index].startTime = null;
            this.form.timesInfoList[index].endTime = null;
        }
    }

    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    public srow: any;
    public srow1: any;
    public srow2: any;
    public srowTy: string = '';
    public removeBook(index) {
        this.srow = index;
        this.setColor = '2';
        this.srowTy = 'a';
        this.dialogConfig = {
            title: '删除',
            show: true,
        };
    }
    async confirmOk() {
        if (this.srowTy == 'a') {
            this.form.timesInfoList.splice(this.srow, 1);
        } else if (this.srowTy == 'b') {
        }
        this.dialogConfig = {
            show: false,
        };
    }
    public async loadDetail() {
        this.loading = true;
        await AppointmentTime.GetTimeWDDetail(this.id)
            .then((res) => {
                setTimeout(() => {
                    if (res) {
                        //回显仓库名称
                        this.wareHouseNamesList = [];
                        if (res.wareHouseIds) {
                            let arr = res.wareHouseIds.split(',');
                            for (let i = 0; i < arr.length; i++) {
                                this.wareHouseIdList.forEach((t) => {
                                    if (t == arr[i]) {
                                        this.wareHouseNamesList.push(parseInt(arr[i]));
                                    }
                                });
                            }
                        }
                        //回显时间范围(去除时分秒)
                        let isBackslash = res.startDate.includes('/');
                        if (!isBackslash) {
                            // let startDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(res.startDate);
                            // let endDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(res.endDate);
                            let startDatearr = res.startDate.split(' ');
                            let endDatearr = res.endDate.split(' ');
                            let startDate = startDatearr[0];
                            let endDate = endDatearr[0];
                            this.dateList = [startDate, endDate];
                        } else {
                            let startDatearr = res.startDate.split(' ');
                            let endDatearr = res.endDate.split(' ');
                            let startDate = startDatearr[0].replace(/\//g, '-');
                            let endDate = endDatearr[0].replace(/\//g, '-');
                            // let startDate = /\d{4}\/\d{1,2}\/\d{1,2}/g.exec(res.startDate);
                            // let endDate = /\d{4}\/\d{1,2}\/\d{1,2}/g.exec(res.endDate);
                            this.dateList = [startDate, endDate];
                        }

                        //回显预约时间
                        if (res.timesInfoList.length > 0) {
                            for (let i = 0; i < res.timesInfoList.length; i++) {
                                res.timesInfoList[i].appointmentTimeList = [];
                                // let startTimeArr = res.timesInfoList[i].startTime.split(':');
                                // let endTimeArr = res.timesInfoList[i].endTime.split(':');
                                // let startTime = startTimeArr[0] + ':' + startTimeArr[1];
                                // let endTime = endTimeArr[0] + ':' + endTimeArr[1];
                                let startTime = res.timesInfoList[i].startTime;
                                let endTime = res.timesInfoList[i].endTime;
                                res.timesInfoList[i].appointmentTimeList = [startTime, endTime];
                            }
                        }
                        this.form = res;
                        // this.loading = false;
                    } else {
                        // this.loading = false;
                    }
                    this.loading = false;
                }, 500);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    /**
     * 新增/编辑
     */
    public save() {
        this.loading = true;
        if (this.pageTitle == '新增时间窗口') {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.timeArr = [];
                    this.form.timesInfoList.forEach((e) => {
                        this.timeArr.push({ startTime: e.startTime, endTime: e.endTime });
                    });
                    let isOverlap = this.Fn();
                    // console.log('isOverlap=====', isOverlap);
                    if (isOverlap) {
                        AppointmentTime.AddTimeWD({ ...this.form })
                            .then((res) => {
                                this.$message.success('新增成功!');
                                this.loading = false;
                                this.$router.push('/timeWindow');
                            })
                            .catch((err) => {
                                this.loading = false;
                            });
                    } else {
                        this.loading = false;
                        this.$message.warning('预约时间不可重叠!');
                    }
                } else {
                    this.loading = false;
                }
            });
        } else {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.timeArr = [];
                    this.form.timesInfoList.forEach((e) => {
                        this.timeArr.push({ startTime: e.startTime, endTime: e.endTime });
                    });
                    let isOverlap = this.Fn();
                    if (isOverlap) {
                        AppointmentTime.EditTimeWD(this.id, { ...this.form })
                            .then((res) => {
                                this.$message.success('编辑成功!');
                                this.loading = false;
                                this.$router.push({
                                    path: '/timeWindow',
                                    query: {
                                        type: 'time',
                                    },
                                });
                            })
                            .catch((err) => {
                                this.loading = false;
                            });
                    } else {
                        this.$message.warning('预约时间不可重叠!');
                        this.loading = false;
                    }
                } else {
                    this.loading = false;
                }
            });
        }
    }
    /**
     * 判断多个时间段是否有重叠
     */
    public timeArr = [];
    public Fn() {
        for (let k in this.timeArr) {
            if (!this.judege(k)) {
                return false;
            }
        }
        return true;
    }
    public judege(idx) {
        for (let k in this.timeArr) {
            if (idx !== k) {
                if (this.timeArr[k].startTime <= this.timeArr[idx].startTime && this.timeArr[k].endTime > this.timeArr[idx].startTime) {
                    return false;
                }
                if (this.timeArr[k].startTime < this.timeArr[idx].endTime && this.timeArr[k].endTime >= this.timeArr[idx].endTime) {
                    return false;
                }
            }
        }
        return true;
    }
    back() {
        this.$router.push('/timeWindow');
    }
}
